<template>
  <BModal
    ref="notification-preview-modal"
    modal-class="notification-preview-modal bottom-right"
    :header-class="[getDialogHeaderClasses, 'font-weight-bold']"
    footer-border-variant="light"
    hide-header-close
  >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <div
          class="notification-icon-circle rounded-circle bg-white d-flex align-items-center justify-content-center mr-2"
          :class="getIconBorderColor(message)"
        >
          <i
            :class="`${getIconClass(
              message
            )} notification-icon fa-lg text-primary`"
          ></i>
        </div>
        <span>{{ message?.previewTitle }}</span>
      </div>
    </template>
    <div v-if="message">
      <vue-editor
        class="reset-style editor-viewer"
        :disabled="true"
        :editor-options="editorOptions"
        v-model="previewBodyModel"
      ></vue-editor>
    </div>

    <template #modal-footer="{ ok }">
      <button
        v-if="
          notificationToBeAccepted &&
          notificationToRead &&
          !isNotificationExpired(message)
        "
        type="button"
        class="btn btn-outline-dark"
        @click="remindLater(ok)"
      >
        {{ $t('app.notifications.remind-me') }}
      </button>

      <button
        v-if="!message?.hasDetail"
        type="button"
        class="btn btn-primary"
        @click="markMessageAsRead(ok)"
      >
        {{
          notificationToBeAccepted && notificationToRead
            ? $t('app.notifications.ok-understood')
            : $t('app.forms.close')
        }}
      </button>

      <button
        v-if="message?.hasDetail"
        type="button"
        class="btn btn-primary"
        @click="openDetail(ok)"
      >
        {{ $t('app.notifications.read-now') }}
      </button>
    </template>
  </BModal>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import notificationsMixin from '~/mixins/notificationsMixin.js'

export default {
  components: {
    VueEditor,
  },
  mixins: [notificationsMixin],
  props: {
    message: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      editorOptions: {
        modules: {
          toolbar: false,
        },
      },
    }
  },
  computed: {
    previewBodyModel: {
      get() {
        return this.message?.previewBody
      },
      set() {},
    },
  },
  methods: {
    showModal() {
      this.$refs['notification-preview-modal'].show()
    },
    openDetail(ok) {
      ok()
      this.$emit('openDetail')
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.bottom-right .modal-dialog) {
  position: fixed;
  margin: 0;
  right: 20px;
  bottom: 20px;
}

:deep(.modal-dialog) {
  width: 28rem !important;
}

:deep(.modal-dialog .modal-content .modal-header h5.modal-title) {
  display: flex;
  align-items: center;
}

.notification-icon {
  line-height: 1;
}

:deep(.editor-viewer .ql-container) {
  border: none;
}

:deep(.editor-viewer .ql-container .ql-editor) {
  padding: 0;
  min-height: fit-content;
}

.editor-viewer {
  max-height: 30rem;
  overflow-y: auto;
}

@keyframes slideInFromRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
